const initArquatiPersonalization = (root = document) => {
  root.querySelectorAll('[data-arquati-personalization]').forEach((wrap) => {
    if (wrap.dataset.ready === 'true') return;
    wrap.dataset.ready = 'true';

    const initialsChoice = wrap.querySelector('[data-personalization-choice="initials"]');
    const imageChoice = wrap.querySelector('[data-personalization-choice="image"]');
    const phraseChoice = wrap.querySelector('[data-personalization-choice="phrase"]');
    const propertyType = wrap.querySelector('[data-personalization-property]');
    const initials = wrap.querySelector('[data-personalization-initials]');
    const file = wrap.querySelector('[data-personalization-file]');
    const phrase = wrap.querySelector('[data-personalization-phrase]');
    const initialPanel = wrap.querySelector('[data-panel="initials"]');
    const imagePanel = wrap.querySelector('[data-panel="image"]');
    const phrasePanel = wrap.querySelector('[data-panel="phrase"]');
    const initialsPreview = wrap.querySelector('[data-initials-preview]');
    const imagePreview = wrap.querySelector('[data-image-preview]');
    const phraseCounter = wrap.querySelector('[data-phrase-counter]');

    const sync = () => {
      const useInitials = Boolean(initialsChoice?.checked);
      const useImage = Boolean(imageChoice?.checked);
      const usePhrase = Boolean(phraseChoice?.checked);
      const selectedLabels = [];
      if (useInitials) selectedLabels.push('Iniziali in oro');
      if (useImage) selectedLabels.push('Immagine personalizzata');
      if (usePhrase) selectedLabels.push('Frase personalizzata');

      initialPanel?.classList.toggle('is-active', useInitials);
      imagePanel?.classList.toggle('is-active', useImage);
      phrasePanel?.classList.toggle('is-active', usePhrase);

      if (propertyType) {
        propertyType.disabled = selectedLabels.length === 0;
        propertyType.value = selectedLabels.join(' + ');
      }
      if (initials) {
        initials.disabled = !useInitials;
        initials.required = useInitials;
      }
      if (file) {
        file.disabled = !useImage;
        file.required = useImage;
      }
      if (phrase) {
        phrase.disabled = !usePhrase;
        phrase.required = usePhrase;
      }
    };

    initialsChoice?.addEventListener('change', sync);
    imageChoice?.addEventListener('change', sync);
    phraseChoice?.addEventListener('change', sync);

    initials?.addEventListener('input', () => {
      const value = initials.value.toUpperCase().replace(/[^A-ZÀ-ÖØ-Ý]/g, '').slice(0, 3);
      initials.value = value;
      if (initialsPreview) initialsPreview.textContent = value ? `${value.split('').join('.')}.` : 'B.E.';
    });

    phrase?.addEventListener('input', () => {
      if (phraseCounter) phraseCounter.textContent = `${phrase.value.length}/30`;
    });

    file?.addEventListener('change', () => {
      if (!imagePreview) return;
      imagePreview.innerHTML = '';
      const selectedFile = file.files?.[0];
      if (!selectedFile) return;
      if (selectedFile.type.startsWith('image/')) {
        const img = document.createElement('img');
        img.alt = 'Anteprima immagine personalizzata';
        img.src = URL.createObjectURL(selectedFile);
        imagePreview.appendChild(img);
      } else {
        const text = document.createElement('span');
        text.textContent = 'PDF selezionato';
        imagePreview.appendChild(text);
      }
    });

    sync();
  });
};

document.addEventListener('DOMContentLoaded', () => initArquatiPersonalization());
document.addEventListener('shopify:section:load', (event) => initArquatiPersonalization(event.target));
